import type { PropType } from 'vue';
import type { TTagProps } from './TTag.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useStyles } from './TTag.styles';

const defaultProps = {
  size: 'medium',
  variant: 'default',
};

export const TTag = defineComponent({
  name: 'TTag',
  props: {
    size: String as PropType<TTagProps['size']>,
    variant: String as PropType<TTagProps['variant']>,
  },
  setup(_props, { slots }) {
    const props = computed(() => merge({}, defaultProps, _props));

    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      `${baseClass.value}--${props.value.variant}`,
      `${baseClass.value}--${props.value.size}`,
    ]);

    return () => (
      <div class={classes.value}>
        {
          props.value.size === 'miniature'
            ? (<div data-testid="t-tag-status-indicator" class={`${baseClass.value}__status-indicator`} />
              )
            : (
                <p data-testid="t-tag-text" class={`${baseClass.value}__text ${baseClass.value}__text--${props.value.size}`}>
                  {slots.default?.()}
                </p>
              )
        }
      </div>
    );
  },
});
